import { refreshFetch, statusCodeHelperResponse } from './axios';
import { logger } from 'utils';

export const RECLAMATION_URL = '/fo/v1/reclamations';

export const getPDL = async () => {
  const axios = refreshFetch();
  const endpoint = '/fo/v1/application/parameters';

  const response = await axios({
    method: 'get',
    url: endpoint,
  });

  logger('getPDLPriceList response', response);

  const data = await statusCodeHelperResponse(response);
  return data;
};

export const sendReclamation = async (data: any) => {
  const axios = refreshFetch();
  const endpoint = RECLAMATION_URL;
  const response = await axios({
    method: 'post',
    url: endpoint,
    data,
  });
  logger('sendReclamation response', response);
  return await statusCodeHelperResponse(response);
};
